// local images
// /////////////////////////////////////////////////////////////////////////////
const user = require('../assets/images/user.png');

// albums (mock local)
// /////////////////////////////////////////////////////////////////////////////
const blankFaceLp = require('../assets/images/albums/blank-face-lp.jpg');
const bornToDie = require('../assets/images/albums/born-to-die.jpg');
const comeAroundSundown = require('../assets/images/albums/come-around-sundown.jpg');
const dearMissLonelyhearts = require('../assets/images/albums/dear-miss-lonelyhearts.jpg');
const exRe = require('../assets/images/albums/ex-re.jpg');
const extraMachine = require('../assets/images/albums/extraordinary-machine.jpg');
const housesOfTheHoly = require('../assets/images/albums/houses-of-the-holy.jpg');
const illuminate = require('../assets/images/albums/illuminate.jpg');
const seaOfCowards = require('../assets/images/albums/sea-of-cowards.jpg');
const stadiumArcadium = require('../assets/images/albums/stadium-arcadium.jpg');
const swimming = require('../assets/images/albums/swimming.jpg');
const theCreekDrank = require('../assets/images/albums/the-creek-drank-the-cradle.jpg');
const theLegendOfMrRager = require('../assets/images/albums/the-legend-of-mr-rager.jpg');
const theLonesomeCrowdedWest = require('../assets/images/albums/the-lonesome-crowded-west.jpg');
const whenWeAllFallAsleep = require('../assets/images/albums/when-we-all-fall-asleep.jpg');
const wishYouWereHere = require('../assets/images/albums/wish-you-where-here.jpg');

export default {
  user,

  blankFaceLp,
  bornToDie,
  comeAroundSundown,
  dearMissLonelyhearts,
  exRe,
  extraMachine,
  housesOfTheHoly,
  illuminate,
  seaOfCowards,
  stadiumArcadium,
  swimming,
  theCreekDrank,
  theLegendOfMrRager,
  theLonesomeCrowdedWest,
  whenWeAllFallAsleep,
  wishYouWereHere
};
